import { render, staticRenderFns } from "./kyk_push.vue?vue&type=template&id=1113d258&scoped=true&"
import script from "./kyk_push.vue?vue&type=script&lang=js&"
export * from "./kyk_push.vue?vue&type=script&lang=js&"
import style0 from "./kyk_push.vue?vue&type=style&index=0&id=1113d258&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1113d258",
  null
  
)

export default component.exports